import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import HttpClient from "../network/http";
import { fetchCsrfToken } from "../context/AuthContext";
import DaumSchoolConfirmService from "../service/daumSchoolConfirm";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function useDaumSchoolConfirm(conditions) {
  const queryClient = useQueryClient();
  const httpClient = new HttpClient(baseURL, () => fetchCsrfToken());
  const daumSchoolConfirmService = new DaumSchoolConfirmService(httpClient);

  const daumSchoolConfirmQuery = useQuery(
    ["daumSchoolConfirm", conditions],
    () => daumSchoolConfirmService.findAllConfirms(conditions),
    {
      enabled: !!conditions?.schoolid && !!conditions?.page,
      staleTime: 1000 * 60 * 1, //1분
    }
  );

  const createOrUpdateConfirm = useMutation(
    (data) => daumSchoolConfirmService.createOrUpdateConfirm(data),
    {
      onSuccess: () =>
        queryClient.invalidateQueries(["daumSchoolConfirm", conditions]),
      onError: (error) => {
        console.error("Error creating:", error);
      },
    }
  );

  return {
    daumSchoolConfirmQuery,
    createOrUpdateConfirm,
  };
}
